import React from 'react'
import { useTable } from '../../Components/useTable';



const Permissions = () => {
const type="Permissions"
    const headCells = [
     
        { id: "name", numeric: false, label: "Name" },
        { id: "created", numeric: false, label: "Created at" },
        { id: "action", numeric: false, label: "Action" },
      ];
   
      const { tableUI } = useTable({
        headCells,
        type
      });
  return (

<div className='admin-body'>
      <div className="table-area">{tableUI}</div>
    </div>
    
  )
}

export default Permissions